import Constants from '../../../utils/Constants';
import { MeetHttpHelper, NO_DATA_MESSAGE } from '../../../utils/HttpHelper';

const GetMeetClassificationFlatData = (trackMedals, isOpenCompetition, trackCareerStats, state, setState) => {
  if (state.isArrayLoading !== true && !state.message) {
    let newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      arrayData: [],
      options: [],
      trackMedals,
      isOpenCompetition,
      trackCareerStats,
      message: 'Loading...'
    };
    setState(newState);

    const url = `/MeetClassification/Flat?=${trackMedals}&=${isOpenCompetition}&=${trackCareerStats}`
    MeetHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          arrayData.unshift({ meetClassificationId: Constants.DEFAULT_ID, typeName: '--' });
          newState = {
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            options: arrayData?.map(x => { return { id: x.meetClassificationId, name: x.typeName }; }),
            areOptionsLoaded: true,
            trackMedals,
            isOpenCompetition,
            trackCareerStats,
            message: ''
          };
          setState(newState);
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

export default GetMeetClassificationFlatData;